import { AlertTriangle, RotateCw } from 'lucide-react'

/**
 * Fallback del ErrorBoundary raíz (main.tsx). Se renderiza FUERA del
 * ThemeProvider, pero los tokens del tema (:root en index.css) están siempre
 * disponibles. Sustituye al antiguo `<div>Algo ha ido mal…</div>` pelado.
 */
export default function ErrorFallback() {
  return (
    <div className="min-h-screen grid place-items-center px-4 bg-page">
      <div className="surface max-w-md w-full p-8 text-center space-y-4">
        <div className="mx-auto w-12 h-12 grid place-items-center rounded-full bg-rose-500/10">
          <AlertTriangle size={24} className="text-rose-600 dark:text-rose-400" />
        </div>
        <h1 className="text-lg font-serif font-semibold t-primary">Algo ha ido mal</h1>
        <p className="text-sm t-muted">
          Se ha producido un error inesperado. Recarga la página para continuar; si el problema
          persiste, avísanos.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-white bg-jr2-600 hover:bg-jr2-700 hover:shadow-glow-jr2"
        >
          <RotateCw size={14} /> Recargar la página
        </button>
      </div>
    </div>
  )
}
